/** Public HTML and its client bundle must share a year, including across New Year. */
export const PUBLIC_COPYRIGHT_YEAR = /^\d{4}-/.test(process.env.NEXT_PUBLIC_DOBI_BUILD_TIME || '')
  ? Number(process.env.NEXT_PUBLIC_DOBI_BUILD_TIME!.slice(0, 4))
  : 2026;
